import React from 'react';

function Header() {
    return (<header>Level 101 Sample Solution - React</header>);
}

export default Header;